<template>
  <div class="home-root">
    <div class="home-box">
      <div class="content common-space-around">

           <!--电话-->
           <div class="warp" style="width:460px;">
              <div class="home-title-one">入驻资料填写</div>
              <div class="home-title-two">
                  <div>深圳繁淼信息科技有限公司</div>
                  <div class="xian"></div>  
               </div>
              
              <div class="common-items-center warpText">
                  <img class="img" src="@/assets/phone.png" alt="">
                  <div class="text">13076925919(陈生)</div>
              </div>
              <div class="common-items-center warpText">
                  <img class="img" src="@/assets/bottom-phone.png" alt="">
                  <div class="text">0755-28100083</div>
              </div>
              <div class="common-items-center warpText">
                  <img class="img" src="@/assets/bottom-location.png" alt="">
                  <div class="text">广东省深圳市宝安区留仙二路南天辉创研中心2楼205室</div>
              </div>
           </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {

}
</script>

<style lang="scss" scoped>
  .home-root{
    width:100%;
    height:764px;
    background-image: url("../../../assets/profileBann.png");
    // background-size:100% 100%;
    box-sizing: border-box;
    padding-top:214px;
    .content{
       width:1200px;
       margin:0 auto;
       .xian{
          width: 30px;
          height: 2px;
          background: #FFFFFF;
          margin: 0 auto;
          margin-top:18px;
          margin-bottom:57px;
        }
       .warpText{
         margin-bottom:20px;
       }
       .img{
         width:22px;
         height:22px;
         margin-right:5px;
       }
       .text{
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
       }
    }
    .home-title-one{
      font-size: 52px;
      font-family: gilroy-bold;
      font-weight: bold;
      color: #FFFFFF;
      letter-spacing: 12px;
      background: linear-gradient(90deg, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0.75) 10%, rgba(255,255,255,0.75) 50%, rgba(255,255,255,0.75) 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .home-title-two{
      font-size:28px;
      font-family: Alibaba_Bold;
      color: #FFFFFF;
      background: linear-gradient(90deg, rgba(238,238,238,0.8) 0%, #F3F3F3 9%, #FFFFFF 50%, #FFFFFF 83%, rgba(255,255,255,0.7) 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      margin-top: 20px;
      margin-bottom:18px;
    }

   
  }
</style>